module.exports = __webpack_public_path__ + "static/text-dailyactivity-949da1f34b9b24c17e73b5365cbdc789.png";